module.exports = (RESTService) ->
  'ngInject'
  RESTService.service('admin/currencies')
